import React from 'react';

import * as Elevated from '@pitaman71/omniglot-introspect';
import {  Checkbox, Chip, FormControlLabel, Input, InputProps, MenuItem, Select, SelectProps } from '@material-ui/core';
import { Clients, Streams } from '@pitaman71/omniglot-live-data';

import { Styler } from '.';

export function AsChip<ValueType>(props: {
    id: string,
    active?: boolean,
    icon?: (value?: ValueType) => JSX.Element,
    onClick?: (value: ValueType) => void,
    domain?: Elevated.Domain<ValueType>,
    value?: ValueType,
    client?: Clients.ScalarClient<ValueType>
  }) {
    const asString = props.domain?.asString();     
    const value_ = props.value;
    if(value_ === undefined) return <React.Fragment></React.Fragment>;
    return <Styler.Chip 
            id={props.id}
            icon={!props.icon ? undefined : props.icon(props.value)} 
            label={!asString ? value_ : asString.to(value_)} 
            onClick={props.active === false || props.onClick === undefined ? undefined : () => props.onClick && props.onClick(value_)}
        />
}

export function AsCheckboxes<ValueType>(props: {
    id: string,
    active?: boolean,
    focus?: boolean,
    order?: ValueType[];
    domain?: Elevated.Domain<ValueType>,
    value?: ValueType,
    client?: Clients.ScalarClient<ValueType>
}) {
    const asString = props.domain?.asString();     
    const asEnumeration = props.domain?.asEnumeration(10);
    const order = props.order || Array.from(asEnumeration ? asEnumeration.forward() : []);
    return <React.Fragment>{order.map(( value, index ) => {
        const name = asString ? asString.to(value) : `${value}` ;
        return (
            <FormControlLabel
                control={<Checkbox id={props.id} checked={props.value === value} inputRef={props.focus !== true || index > 0 ? undefined : input => input?.focus()} onChange={props.active === false ? undefined : (event) => {
                    if(!event.target.checked) props.client?.clear()
                    else props.client?.assign(value);
                }} name={name} />}
                label={name}
            />
        );
    })}</React.Fragment>
}

export function AsSelect<ValueType extends string|number>(props: SelectProps & {
    active?: boolean,
    order: ValueType[];
    domain?: Elevated.Domain<ValueType>,
    value?: ValueType,
    client?: Clients.ScalarClient<ValueType>
}) {
    const asString = props.domain?.asString();
    return (
        <Select
            {...props}
            value={props.value === undefined ? '' : props.value}
            onChange={props.active === false || !props.client ? undefined : (event) => {
                props.client?.assign(event.target.value as ValueType)
            }}
        >
            {
                props.order?.map((value, index) => (
                    <MenuItem value={value}>{ asString ? asString.to(value) : `${value}` }</MenuItem>
                ))
            }
        </Select>

    )
}

export function AsElement<ValueType>(props: {
    domain?: Elevated.Domain<ValueType>,
    value?: ValueType,
    client?: Clients.ScalarClient<ValueType>,
    render?: (value:string) => JSX.Element
}) {    
    const asString = props.domain?.asString();
    const text_ = props.value === undefined ? '' : !!asString ? asString.to(props.value) : `${props.value}`
    if(props.render) return props.render(text_);
    return <span>{text_}</span>;
}

export function AsInput<ValueType>(props: {
    active?: boolean,
    inputProps?: InputProps,
    domain?: Elevated.Domain<ValueType>,
    value?: ValueType,
    client?: Clients.ScalarClient<ValueType>
}) {    
    const asString = props.domain?.asString();
    return <Input
        {...props.inputProps}
        value={props.value === undefined ? undefined : !!asString ? asString.to(props.value) : props.value} 
        onChange={props.active === false ? undefined : (event:any) => { 
            if(event.target.value === null || event.target.value === undefined || event.target.value === "") {
                props.client?.clear();
            } else {
                props.client?.assign(!!asString ? asString.from(event.target.value) : event.target.value);
            }
        }}
    />;
}

